"use client"

import { useState, useEffect } from "react"
import "../styles/about-us-section.css"

export default function AboutUsSection() {
  const [isVisible, setIsVisible] = useState(false)
  const [animatedParagraphs, setAnimatedParagraphs] = useState(new Set())

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target.id === "about-section") {
              setIsVisible(true)
            } else if (entry.target.classList.contains("about-paragraph")) {
              const index = Number.parseInt(entry.target.dataset.index)
              setAnimatedParagraphs((prev) => new Set([...prev, index]))
            }
          }
        })
      },
      { threshold: 0.1 },
    )

    const section = document.getElementById("about-section")
    const paragraphs = document.querySelectorAll(".about-paragraph")

    if (section) observer.observe(section)
    paragraphs.forEach((p) => observer.observe(p))

    return () => observer.disconnect()
  }, [])

  const paragraphs = [
    "At Haronics Consumer Products LLP, we are driven by a passion for purity, wellness, and sustainability. Founded with the vision to promote healthier living, Haronics is committed to offering high-quality, natural consumer products that blend traditional wisdom with modern needs. Our flagship range of cold pressed oils is a reflection of our core values—purity, authenticity, and transparency.",

    "We believe in going back to nature to move forward in health. We are dedicated to producing premium-quality cold pressed oils using traditional wooden Ghani methods that retain the natural aroma, nutrients, and purity of seeds—just as nature intended. Our oils are 100% chemical-free, unrefined, and extracted at low temperatures to preserve essential antioxidants, vitamins, and healthy fats.",

    "Sourced from carefully selected farms, every drop of Haronics Cold Pressed Oil embodies our commitment to wellness, sustainability, and authenticity. We strive to bring purity to your plate and wellness to your lifestyle—naturally and honestly.",

    "Every product we offer is carefully crafted, using time-tested processes like the wooden Ghani method to retain natural nutrients and deliver wholesome goodness. We source the finest raw materials directly from trusted farmers, ensuring quality at every stage—from seed to shelf.",

    "As a company, we prioritize eco-conscious practices, ethical sourcing, and customer well-being. Whether it's through our food-grade oils or future wellness innovations, Haronics stands for trust, tradition, and transformation.",
  ]

  return (
    <section id="about-section" className="about-section-text-container">
      <div className="about-background-pattern"></div>
      <div className="about-container">
        <div className="about-header">
          <h2 className={`about-title ${isVisible ? "about-title-visible" : ""}`}>About Us</h2>
          <div className={`about-title-underline ${isVisible ? "about-underline-visible" : ""}`}></div>
        </div>

        <div className="about-content">
          {paragraphs.map((paragraph, index) => (
            <div
              key={index}
              className={`about-paragraph ${animatedParagraphs.has(index) ? "paragraph-visible" : ""}`}
              data-index={index}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="paragraph-icon">
                <div className="icon-dot"></div>
              </div>
              <p className="paragraph-text">{paragraph}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
